export const normalizeContractCups = (value) => String(value ?? '').replace(/\s+/g, '').toUpperCase();

export const isValidContractCups = (value) => {
  const match = normalizeContractCups(value).match(/^ES(\d{16})([A-Z]{2})(?:\d[A-Z])?$/);
  if (!match) return false;
  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  let remainder = 0;
  for (const digit of match[1]) remainder = (remainder * 10 + Number(digit)) % 529;
  return match[2] === letters[Math.floor(remainder / 23)] + letters[remainder % 23];
};
